module.exports = __webpack_public_path__ + "static/media/details__alert.84dd77c9.svg";